import { select, useDispatch } from '@ps/web-core-store';
import type React from 'react';
import { useSelector } from 'react-redux';

import ActiveTableIcon from '../../assets/icons/active-table.svg';
import { StarsButton } from '../buttons';

import styles from './ActiveTableButton.module.scss';

const ActiveTableButton: React.FC = () => {
  const { modal } = useDispatch();
  const games = useSelector(select.activeGames.getGames);

  const openActiveGamesModal = () =>
    modal.enqueue({
      path: '/poker/active-games',
      locationState: {}
    });

  return (
    <div className={styles.wrap}>
      <StarsButton
        className={styles.activeTableButton}
        icon={<ActiveTableIcon />}
        type="button"
        onClick={openActiveGamesModal}
      />
      {!!games.length && <span className={styles.badge}>{games.length}</span>}
    </div>
  );
};

ActiveTableButton.defaultProps = {
  games: []
};

export default ActiveTableButton;
